<style scoped lang="less" rel="stylesheet/less" scoped>
.announce {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  z-index: 998;
}
.announce__topImg {
  width: 100%;
  height: auto;
  margin-top: -31px;
}
.announce__dialog {
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 459px;
  box-sizing: border-box;
  padding: 100px 42px 0 42px;
  border-radius: 20px;
  background: url(../../assets/img/basic/announce/announce_top.png) no-repeat
      left -28px,
    #fff;
  background-size: contain;
}
.announce__bgImg {
  position: absolute;
  display: block;
  top: -29px;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
}
.announce__title {
  margin-top: 72px;
  font-family: PingFang_Regular;
  font-size: 30px;
  line-height: 30px;
  color: #004466;
}
.announce__content {
  margin-top: 28px;
  padding-bottom: 44px;
  font-family: PingFang_Regular;
  font-size: 21px;
  color: #004466;
  line-height: 1.5;
  text-align: left;
  word-break: normal;
}
.announce__link {
  display: block;
  text-decoration: none;
  background: #008ACF;
  width: 373.5px;
  height: 61px;
  border-radius: 36px;
  font-family: PingFang_Regular;
  font-size: 30px;
  color: #ffffff;
  line-height: 57px;
  margin: 0 auto 40px;
}
.announce__link:hover {
  background: #0b88ab;
}
.announce_closeIcon {
  position: absolute;
  display: block;
  top: -55px;
  left: 0;
  right: 0;
  width: 43px;
  height: auto;
}

.announce-fade-enter-active {
  transition: all 0.3s ease;
}
.announce-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.announce-fade-enter,
.announce-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
<template>
  <transition name="announce-fade">
    <div class="announce">
      <div class="announce__dialog">
        <!-- <img class="announce__bgImg" src="../../assets/img/basic/announce/announce_top.png" alt> -->
        <div class="announce__title" v-text="datas.title"></div>
        <div class="announce__content">{{datas.content}}</div>
        <a
          class="announce__link"
          v-show="hasLink"
          href="javascript:;;"
          @click.stop="open_page"
          v-text="datas.btnText"
        ></a>
        <img
          class="announce_closeIcon"
          v-show="canClose"
          @click.stop="closeWindow"
          src="../../assets/img/basic/announce/announce_close.png"
        >
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import common from "common";
if (LIMI_ENV === "electron") {
  var { shell } = window.require("electron");
}
export default {
  data: function() {
    return {
      // info: {
      //   id: "", //公告id
      //   title: "", //公告标题
      //   content: "", //公告内容
      //   notice_type: "", //公告样式（1：强制跳转，2：可跳转、可关闭，3：无跳转、可关闭）
      //   btn_text: "", //跳转按钮文字
      //   btn_url: "", //按钮跳转链接
      //   show_type: "" //显示频次（1：仅一次，2：每次应用重启显示）
      // }
    };
  },
  props: {
    datas: {
      type: Object
    }
  },
  computed: {
    canClose() {
      return this.datas.noticeType == "2" || this.datas.noticeType == "3";
    },
    hasLink() {
      return this.datas.noticeType == "1" || this.datas.noticeType == "2";
    }
  },
  methods: {
    open_page(url) {
      if (LIMI_ENV === "electron") {
        shell.openExternal(this.datas.btnUrl);
      } else {
        window.open(this.datas.btnUrl, "_blank");
      }
        this.$root.eventHub.$emit("showPopup",'b_announce');
    },
    closeWindow(){
        this.$root.eventHub.$emit("showPopup",'b_announce');
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/basic/announce.vue